(function ($, scrollingElement) {
  'use strict';

  $(document).ready(init);

  function init() {
    var $sectionLinks = $('.block-product-nav__item-link');
    if (!$sectionLinks.length) { return; }

    calculatePositions($sectionLinks);
    $(window).on('resize', function () {
      calculatePositions($sectionLinks);
    });

    $(window).on('scroll', function () {
      var scrollPosition = scrollingElement.scrollTop;
      $sectionLinks.removeClass('block-product-nav__item-link--active');

      var $activeLink = null;
      $sectionLinks.each(function () {
        if (scrollPosition < this._ankerPosition) {
          return false;
        }
        $activeLink = $(this);
      });

      if ($activeLink) {
        $activeLink.addClass('block-product-nav__item-link--active');
      }
    });
  }

  function calculatePositions($sectionLinks) {
    $sectionLinks.each(function () {
      var $link = $(this);
      $link[0]._ankerPosition = $($link.attr('href'))[0].offsetTop;
    });
  }

})(jQuery, document.scrollingElement);
